var Reverb = window.Reverb || {};

Reverb.RefundRequestAdjustment = (function () {
  var refundAmount = '[data-refund-original-amount]';

  function init() {
    $(document).on('input', refundAmount, adjustSellerFees);
  }

  function adjustSellerFees() {
    var $refundAmountInput = $(this);
    if ($refundAmountInput.val() < $refundAmountInput.data('refund-original-amount')) {
      $($refundAmountInput.data('full')).hide();
      $($refundAmountInput.data('partial')).show();
    } else {
      $($refundAmountInput.data('full')).show();
      $($refundAmountInput.data('partial')).hide();
    }
  }

  return {
    init: init
  };
})();

$(document).ready(Reverb.RefundRequestAdjustment.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/dashboard/refund_request_adjustment.js